<template>
  <pt-fast-loan-audit-detail class="pt-fast-loan-audit-detail__withData" :id="id" :flashBorrowDetail="flashBorrowDetail" @flashBorrowAudit="flashBorrowAudit"
  :loading="loading" :submitLoading="submitLoading" @flashBorrowCompleted="flashBorrowCompleted" ref="form"></pt-fast-loan-audit-detail>
</template>

<script>
import PtFastLoanAuditDetail from './index'
export default {
  name: 'pt-fast-loan-audit-detail__withData',
  components: {
    'pt-fast-loan-audit-detail': PtFastLoanAuditDetail
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      flashBorrowDetail: {},
      loading: false,
      submitLoading: false
    }
  },
  computed: {
    form () {
      return this.$refs.form
    }
  },
  methods: {
    flashBorrowCompleted (id) {
      let data = {
        flashBorrowId: id
      }
      this.$store.dispatch('flashBorrowComponent', data).then(res => {
        this.$message.success('完成银行分期返惠成功')
        this.$refs.table.getTableData(this.page)
      }).catch(err => {
        this.$message.error(err || '完成银行分期返惠失败')
      })
    },
    flashBorrowAudit (data) {
      this.form.validate().then(res => {
        this.submitLoading = true
        this.$store.dispatch('flashBorrowAudit', data).then(res => {
          this.$message.success('银行分期返惠审核成功')
          this.submitLoading = false
          this.getFlashBorrowDetail()
        }).catch(err => {
          this.submitLoading = false
          this.$message.error(err || '银行分期返惠审核失败')
        })
      })
    },
    getFlashBorrowDetail () {
      this.loading = true
      this.$store.dispatch('flashBorrowDetail', this.id).then(res => {
        this.flashBorrowDetail = res
        this.loading = false
      }).catch(err => {
        this.$message.error(err || '获取详情失败')
        this.loading = false
      })
    }
  },
  created () {
    this.getFlashBorrowDetail()
  }
}
</script>
